import { Button, Input } from "@devhop/ui";
import { ArrowDownAZ, ArrowUpAZ } from "lucide-react";
import {
  SimpleSelect,
  type SimpleSelectOption,
} from "@/shared/ui/SimpleSelect";

type TrainingListControlsProps = {
  /** ຄື checklist: `id` ສຳລັບ input + `htmlFor` ຂອງ sr-only label */
  filterInputId: string;
  filterLabel: string;
  filterQuery: string;
  onFilterChange: (value: string) => void;
  searchPlaceholder: string;
  filteredCount: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  sortOptions: SimpleSelectOption[];
  onSortByChange: (sortBy: string) => void;
  onSortOrderToggle: () => void;
  searchTourId?: string;
};

/**
 * ແຖບຄົ້ນຫາ + ຈັດລຳດັບ — ຮູບແບບດຽວກັນກັບໜ້າ ລາຍການກວດສອບ (ChecklistPickerPanel).
 */
export function TrainingListControls({
  filterInputId,
  filterLabel,
  filterQuery,
  onFilterChange,
  searchPlaceholder,
  filteredCount,
  sortBy,
  sortOrder,
  sortOptions,
  onSortByChange,
  onSortOrderToggle,
  searchTourId,
}: TrainingListControlsProps) {
  return (
    <div className="mt-4 overflow-hidden" data-tourid={searchTourId}>
      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <label className="sr-only" htmlFor={filterInputId}>
          {filterLabel}
        </label>
        <Input
          id={filterInputId}
          type="search"
          placeholder={searchPlaceholder}
          value={filterQuery}
          onChange={(e) => onFilterChange(e.target.value)}
          className="w-full max-w-xl"
        />
        <p className="text-muted-foreground text-sm">
          ພົບ {filteredCount} ລາຍການ
        </p>
      </div>

      <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <span className="shrink-0 text-muted-foreground text-sm">ຈັດລຳດັບ</span>
        <div className="flex flex-wrap items-center gap-2">
          <SimpleSelect
            value={sortBy}
            onValueChange={onSortByChange}
            options={sortOptions}
            className="w-full max-w-[220px] sm:w-[220px]"
          />
          <Button
            type="button"
            variant="outline"
            size="icon"
            className="size-9 shrink-0"
            aria-label={
              sortOrder === "asc"
                ? "ລຽງຈາກ A ຫາ Z — ກົດເພື່ອກັບລຽງສວນທາງ"
                : "ລຽງຈາກ Z ຫາ A — ກົດເພື່ອກັບລຽງສວນທາງ"
            }
            title={sortOrder === "asc" ? "ລຽງຂຶ້ນ (A→Z)" : "ລຽງລົງ (Z→A)"}
            onClick={onSortOrderToggle}
          >
            {sortOrder === "asc" ? (
              <ArrowUpAZ className="size-4" />
            ) : (
              <ArrowDownAZ className="size-4" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
